declare global {
  interface Window {
    onAppleScriptLoaded?: () => void;
  }
}

let scriptLoadedPromise: Promise<void> | null = null;

export const loadAppleScript = (): Promise<void> => {
  // Check if the script is already loaded
  // This is only added as a precaution as the script should only be loaded once
  // and could be loaded by a different component/code
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Not needed in ssr environment"));
  }

  // If the script is currently being loaded, return the existing promise
  if (scriptLoadedPromise != null) {
    return scriptLoadedPromise;
  }

  // Create a promise to load the script
  scriptLoadedPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js?";
    script.async = true;
    script.defer = true;
    script.onerror = () => reject(new Error(`Failed to load Apple script`));

    // Define the global callback that resolves the promise
    script.onload = () => {
      resolve();
    };

    document.head.appendChild(script);
  });

  return scriptLoadedPromise;
};
